export function quickSelectMedian(arr: any) {
  if (!arr.length) return null;
  
  const findKth = (k: any, nums: any) => {
    if (nums.length === 1) return nums[0];
    
    const pivot = nums[0];
    const left = [], right = [], equal = [];
    
    for (const num of nums) {
      if (num < pivot) left.push(num);
      else if (num > pivot) right.push(num);
      else equal.push(num);
    }
    
    if (k < left.length) return findKth(k, left);
    if (k < left.length + equal.length) return pivot;
    return findKth(k - left.length - equal.length, right);
  };
  
  const n = arr.length;
  const mid = Math.floor(n / 2);
  
  if (n % 2 === 0) {
    return (findKth(mid - 1, [...arr]) + findKth(mid, [...arr])) / 2;
  } else {
    return findKth(mid, [...arr]);
  }
}